import { useMemo } from "react";

import { useHistory } from "react-router-dom";

import { useGetMargin, useGetTradingAccount } from "~/v2/api/hooks";
import { MARGIN_POLLING_INTERVAL } from "~/v2/constants";
import { FeatureFlags, useFeatureEnabled } from "~/v2/helpers/featureFlags";
import { Path } from "~/v2/path";
import { useAccountContext } from "~/v2/providers/AccountProvider";
import { useAcatsBanners } from "./hooks/useAcatsBanners";

export const useHomeController = () => {
  const history = useHistory();
  const { product, currentAccount, refetchLiveAccounts } = useAccountContext();
  const { account: tradingAccount } = useGetTradingAccount();

  const isIraContributionCardEnabled = useFeatureEnabled(
    FeatureFlags.IRA_CONTRIBUTIONS_CARD,
  );

  const { margin, isLoading: isMarginLoading } = useGetMargin({
    accountID: currentAccount?.id,
    paper: product === "paper",
    options: {
      enabled: !!currentAccount?.id,
      refetchInterval: MARGIN_POLLING_INTERVAL,
      staleTime: 5000,
    },
  });

  // Determine which account to show the status banner for
  const statusBannerAccount = useMemo(() => {
    if (product === "live" && currentAccount) {
      return currentAccount;
    }
    if (
      product === "paper" &&
      tradingAccount &&
      tradingAccount.status !== "ACTIVE"
    ) {
      return tradingAccount;
    }
    return null;
  }, [product, currentAccount, tradingAccount]);

  const acatsBannerItems = useAcatsBanners();

  const showIRAContributionCard =
    isIraContributionCardEnabled &&
    !!currentAccount &&
    currentAccount.account_type === "ira";

  const onBalancesClick = () => {
    history.push(Path.ROUTE_BALANCES);
  };

  const onInterestPaidClick = () => {
    history.push(Path.ROUTE_PROGRAM_INTEREST);
  };

  const onViewAllOrders = () => {
    history.push(Path.ROUTE_ORDERS);
  };

  return {
    statusBannerAccount,
    refetchLiveAccounts,
    acatsBannerItems,
    margin,
    isMarginLoading,
    currentAccount,
    showIRAContributionCard,
    onBalancesClick,
    onInterestPaidClick,
    onViewAllOrders,
  };
};
